const SearchPaletteHook = {
  mounted() {
    const id = this.el.id;

    this.handleEvent(`search-palette:${id}:close`, () => {
      window.liveSocket.execJS(this.el, this.el.dataset.height);
    });
  },
};

export default SearchPaletteHook;
